/* fh-milestones.js [CUSTOM] · milestones-1020, 20 Oct 2026 (the 19 Oct strip's motion, moved to one track). Motion for the
   bag's reward track (snippets/cart-drawer.liquid renders it, assets/fh-cart-drawer.css styles it). The drawer's HTML is
   swapped on every cart change, so this file loads outside it (sections/cart-drawer.liquid) and watches <cart-drawer>.
   When the drawer is open and the track has moved since the shopper last saw it, the fill runs from where it was to
   where it is, and a mark it passes on the way up fills in as the fill gets there. A plain open, a reopen, a reload with
   the same bag, or reduced motion plays nothing. The bar carries its fill (data-f, per mille) and how many rewards the
   bag has reached (data-s); each mark carries where it sits (--p, per mille). */
(function () {
  var KEY = 'fhms:f';
  var RUN = 520; // the fill's run in ms, as fhms-run in the CSS
  var still = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function nums(s) {
    var p = String(s).split(',').map(Number);
    return p.length === 2 && !isNaN(p[0]) && !isNaN(p[1]) ? p : null;
  }
  function seen() {
    try { return nums(sessionStorage.getItem(KEY)); } catch (e) { return null; }
  }
  function keep(v) {
    try { sessionStorage.setItem(KEY, v.join(',')); } catch (e) {}
  }
  // the share of the run's time by which the eased fill (cubic-bezier(.23,1,.32,1), as fhms-run) has covered a share q of
  // its way: both control points sit at y = 1, so y(s) = 1 - (1 - s)^3 and s comes back exact
  function at(q) {
    var s = 1 - Math.pow(1 - q, 1 / 3);
    return 3 * (1 - s) * (1 - s) * s * 0.23 + 3 * (1 - s) * s * s * 0.32 + s * s * s;
  }

  function play(drawer, wait) {
    if (!drawer.classList.contains('active')) return;
    var bar = drawer.querySelector('[data-fhms]');
    if (!bar) {
      if (drawer.querySelector('.drawer__inner-empty')) keep([0, 0]);
      return;
    }
    if (bar.hasAttribute('data-fhms-played')) return;
    bar.setAttribute('data-fhms-played', '');
    var now = nums(bar.getAttribute('data-f') + ',' + bar.getAttribute('data-s'));
    if (!now) return;
    var was = seen();
    keep(now);
    if (!was || (was[0] === now[0] && was[1] === now[1]) || (still && still.matches)) return;
    bar.style.setProperty('--g', was[0]);
    bar.style.setProperty('--d', wait + 'ms');
    bar.classList.add('is-grow');
    if (was[1] !== now[1]) bar.classList.add('is-new');
    if (now[1] <= was[1]) return;
    // the marks reached since last time: each fills in the moment the eased fill gets to it
    var steps = bar.querySelectorAll('.fhms__step');
    var span = Math.max(1, now[0] - was[0]);
    Array.prototype.forEach.call(bar.querySelectorAll('.fhms__node'), function (node, i) {
      var p = parseFloat(node.style.getPropertyValue('--p'));
      if (!node.classList.contains('is-on') || isNaN(p) || p <= was[0]) return;
      var d = Math.round(wait + RUN * at(Math.min(1, (p - was[0]) / span))) + 'ms';
      node.style.setProperty('--d', d);
      node.classList.add('is-new');
      if (steps[i]) {
        steps[i].style.setProperty('--d', d);
        steps[i].classList.add('is-new');
      }
    });
  }

  // Avante hides a closed drawer with display:none, and showing it again restarts any CSS animation still attached, so
  // the motion is taken off on close: a reopen shows the bar at rest (19 Oct check: 11 animations replayed)
  function settle(drawer) {
    Array.prototype.forEach.call(drawer.querySelectorAll('.fhms.is-grow, .fhms.is-new, .fhms .is-new'), function (el) {
      el.classList.remove('is-grow', 'is-new');
    });
  }

  function watch(drawer) {
    // a swap inside an open drawer plays at once; an opening drawer waits for its 360ms slide to get going
    new MutationObserver(function () { play(drawer, 40); }).observe(drawer, { childList: true, subtree: true });
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) play(drawer, 220); else settle(drawer);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    if (!drawer.querySelector('[data-fhms]') && drawer.querySelector('.drawer__inner-empty')) keep([0, 0]);
    play(drawer, 0);
  }

  Array.prototype.forEach.call(document.querySelectorAll('cart-drawer'), watch);
})();
